import useTheme from '@mui/material/styles/useTheme';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { MutableRefObject } from 'react';
import { useAddonStyles, useMakeResponsiveStyles } from 'kineticUtils';

interface HeaderStyleProps {
  title?: string | React.ReactNode;
  expanded?: boolean;
}

const usePageHeaderStyles = makeStyles(({ palette, spacing, typography }) => {
  const { addons } = useAddonStyles(spacing);
  return createStyles({
    heading: {
      maxHeight: '1em',
    },
    titleWrapper: {
      display: 'flex',
      alignItems: 'center',
      height: typography.h1.fontSize,
    },
    wrapper: {
      backgroundColor: palette.primary.light,
      padding: `${spacing(2)} ${spacing(3)} ${spacing()}`,

      paddingTop: spacing(2),
      paddingBottom: ({ expanded }: HeaderStyleProps) => (expanded ? 75 : ''),
      marginBottom: ({ expanded }: HeaderStyleProps) => (expanded ? -68 : spacing(2)),
      boxSizing: 'content-box',
    },
    headerTitleWrapper: {
      maxHeight: '1em',
      fontSize: '1.2em',
    },
    subtitle: {
      color: palette.grey[900],
      fontSize: 14,
      lineHeight: 0,
      paddingTop: 6,
      paddingBottom: 4,
    },
    addons: addons,
    bookmarkName: {
      display: 'flex',
      marginLeft: spacing(),
      marginRight: spacing(),
      paddingTop: spacing(),
    },
    rightColumn: {
      marginLeft: 'auto',
    },
    leftSideAddons: {
      ...addons,
      marginLeft: 0,
      '& > *': {
        marginLeft: spacing(-3),
        marginRight: spacing(),
      },
    },
  });
});

export default usePageHeaderStyles;

export const useResponsiveStyles = (containerRef: MutableRefObject<HTMLElement | null>) => {
  const { spacing } = useTheme();

  return useMakeResponsiveStyles(containerRef, {
    headerTitleWrapper: {
      base: {
        maxWidth: spacing(248),
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
      sm: { maxWidth: spacing(100) },
      md: { maxWidth: spacing(140) },
      lg: { maxWidth: spacing(195) },
    },
  });
};
